module.exports = __webpack_public_path__ + "img/jantar-halifax.c39cc67a.jpeg";